import React from "react";
import MainLayout from "../../../components/Layouts";
import ShopOrdersList from "../../../components/Orders/myShopOrderList";

const MyShopOrderPage = () => {
  return (
    <MainLayout>
      <ShopOrdersList />
    </MainLayout>
  );
};

export default MyShopOrderPage;
